import './google_my_business_content.js.coffee'
Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReplyContent extends
Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessContent
  @SUB_TYPE = 'google-my-business-reply'

  constructor: (author, reply, locationSummary) ->
    @reply = reply
    super(author, locationSummary)

  getMainText: =>
    @reply.getText()

  getContentId: =>
    @reply.getContentId()

  getCreatedAt: =>
    @reply.getCreatedAt()

  getParentId: =>
    @getReviewId()

  getReviewId: =>
    @getReviewSnapshot().getReviewId()

  getReviewSnapshot: =>
    @reply.getReviewSnapshot()

  isBrandContent: ->
    true

  getSubType: ->
    Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReplyContent.SUB_TYPE

  getPrivacy: ->
    'public'

  hasRelated: ->
    false
